import { render, staticRenderFns } from "./MatrPush9002.vue?vue&type=template&id=554d8704&scoped=true&"
import script from "./MatrPush9002.vue?vue&type=script&lang=js&"
export * from "./MatrPush9002.vue?vue&type=script&lang=js&"
import style0 from "./MatrPush9002.vue?vue&type=style&index=0&id=554d8704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d8704",
  null
  
)

export default component.exports